module.exports = __webpack_public_path__ + "static/media/Mission_mobile2_SV.7dc643d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mission_mobile2_SV.png
// module id = 1063
// module chunks = 0